<template>
  <header id="header">
    <span class="avatar">
      <img src="@/assets/images/logo.png" alt />
    </span>
    <h1>
      <strong>Balcony Games</strong> we are gamers and making games for people with the same mind set.
    </h1>

    <ul class="icons">
      <li>
        <a href="https://twitter.com/balconygames" class="style2 icon" target='_blank'>
          <font-awesome-icon :icon="['fab', 'twitter']" />
          <span class="label">Twitter</span>
        </a>
      </li>
      <li>
        <a href="https://facebook.com/balconygames" class="style2 icon" target='_blank'>
          <font-awesome-icon :icon="['fab', 'facebook']" />
          <span class="label">Facebook</span>
        </a>
      </li>
      <li>
        <a href="https://instagram.com/balconygames" class="style2 icon" target='_blank'>
          <font-awesome-icon :icon="['fab', 'instagram']" />
          <span class="label">Instagram</span>
        </a>
      </li>
      <li>
        <a href="https://dev.to/balconygames" class="style2 icon" target='_blank'>
          <font-awesome-icon :icon="['fab', 'dev']" />
          <span class="label">Dev.to</span>
        </a>
      </li>
      <li>
        <a href="mailto:team@balconygames.com" class="style2 icon" target='_blank'>
          <font-awesome-icon icon="envelope" />
          <span class="label">Email</span>
        </a>
      </li>
      <li>
        <a href="https://discord.gg/d6vJ4ERcsd" class="style2 icon" target='_blank'>
          <font-awesome-icon :icon="['fab', 'discord']" />
        </a>
      </li>
    </ul>
  </header>
</template>

<script>
export default {
  name: "Header",
};
</script>

<style scoped>
@media screen and (max-width: 768px) {
  #header {
    text-align: center;
  }

  #header .icons {
    justify-content: center;
    display: flex;
    flex-wrap: wrap;
  }

  #header .icons li {
    width: 25%; /* Makes 4 items per row */
    margin-bottom: 1rem;
  }
}
</style>
